/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.reports.create.modals.selectTime.controllers', [
  'ui.bootstrap',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences'
])

.controller('ReportsCreateModalsSelectTimeController', ['$scope', '$filter', '$uibModalInstance', 'CalendarService', 'HelpersService', 'UserPreferencesService', 'fromTime', 'toTime', 'fromDate', 'toDate', 'isRange', function($scope, $filter, $uibModalInstance, CalendarService, HelpersService, UserPreferencesService, fromTime, toTime, fromDate, toDate, isRange) {

    $scope.reportsCreateModalsSelectTime = {

      model: {},
      errors: [],
      cutoff: 'daily',
      cutoffOptions: [
        {
          name: 'daily',
          label: 'Daily'
        },
        {
          name: 'range',
          label: 'Start and end with range'
        }
      ],
      isRange: false,
      fromTime: '',
      toTime: '',
      fromDate: '',
      toDate: '',
      fromDisplayDate: '',
      toDisplayDate: '',
      dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),

      init: function() {
        this.isRange = (isRange);
        this.fromTime = CalendarService.timeToDate(fromTime);
        this.toTime = CalendarService.timeToDate(toTime);
        this.fromDate = CalendarService.parseDate(fromDate, this.dateFormat);
        this.toDate =  CalendarService.parseDate(toDate, this.dateFormat);
        this.fromDisplayDate = $filter('date')(CalendarService.parseDate(fromDate, this.dateFormat));
        this.toDisplayDate =  $filter('date')(CalendarService.parseDate(toDate, this.dateFormat));

        $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      },

      onDateFormatLoad: function (e, data) {
        var self = $scope.reportsCreateModalsSelectTime;
        self.dateFormat  = UserPreferencesService.getDateFormat('shortDate', 'dateFormat');
      },

      getFromDateTime: function() {
        return CalendarService.toISO8601(new Date(
          this.fromDate.getFullYear(),
          this.fromDate.getMonth(),
          this.fromDate.getDate(),
          this.fromTime.getHours(),
          this.fromTime.getMinutes(),
          0,
          0
        ));
      },

      getToDateTime: function() {
        return CalendarService.toISO8601(new Date(
          this.toDate.getFullYear(),
          this.toDate.getMonth(),
          this.toDate.getDate(),
          this.toTime.getHours(),
          this.toTime.getMinutes(),
          59,
          999
        ));
      },

      done: function() {
        $uibModalInstance.close({
          fromTime: $filter('date')(this.fromTime, HelpersService.dateFormats.standardTime),
          toTime: $filter('date')(this.toTime, HelpersService.dateFormats.standardTime),
          fromDate: this.fromDate,
          toDate: this.toDate,
          fromDateTime: this.getFromDateTime(),
          toDateTime: this.getToDateTime()
        });
      },

      cancel: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.reportsCreateModalsSelectTime.init();

}])
.controller('ReportsCreateModalsDatePickerController', ['$scope', '$timeout', 'HelpersService', 'UserPreferencesService', function($scope, $timeout, HelpersService, UserPreferencesService) {
  $scope.reportsCreateModalsDatePicker = {

    isOpen: false,

    isPreferenceLoaded: false,

    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false
    },

    init: function() {
      this.today();
      $scope.initDate = new Date('2016-15-20');
      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'yyyyMMdd', 'shortDate'];
      $scope.format = $scope.formats[3];
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
        $scope.reportsCreateModalsDatePicker.isPreferenceLoaded = true;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    },

    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.isOpen = true;
    },

    onDateFormatLoad: function (e, data) {
      var self = $scope.reportsCreateModalsDatePicker;
      self.dateFormat  = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }

  };

  $scope.reportsCreateModalsDatePicker.init();

}]);